module.exports = __webpack_public_path__ + "img/enable-2fa.dfea1241.svg";